import { Props } from "./types";

const HorizontalBar = ({ className }: Props): JSX.Element => {
  return <div className={`${className} w-full h-px mx-auto bg-grey-200`} />;
};

export default HorizontalBar;
